import {
  IconCreditCard,
  IconGraduation,
  IconPhone,
  IconTv,
  IconWifi,
  IconZap,
  ServiceIconBox,
} from '@/components/landing/LandingIcons';

const services = [
  {
    title: 'Data Bundles',
    desc: 'Get cheap data bundles for all networks. MTN SME, Airtel CG, Glo, and 9mobile at discounted rates.',
    icon: IconWifi,
    tone: 'orange' as const,
  },
  {
    title: 'Airtime Topup',
    desc: 'Instant airtime recharge for MTN, Airtel, Glo, and 9mobile. VTU and Share & Sell available.',
    icon: IconPhone,
    tone: 'green' as const,
  },
  {
    title: 'Cable TV',
    desc: 'Subscribe to DSTV, GOTV, and Startimes packages instantly. Never miss your favorite shows.',
    icon: IconTv,
    tone: 'orange' as const,
  },
  {
    title: 'Utility Bills',
    desc: 'Pay electricity bills for all DisCos - IKEDC, EKEDC, AEDC, PHED, KEDCO, and more.',
    icon: IconZap,
    tone: 'green' as const,
  },
  {
    title: 'Education',
    desc: 'Buy WAEC, NECO, and NABTEB result checker pins and scratch cards at best prices.',
    icon: IconGraduation,
    tone: 'orange' as const,
  },
  {
    title: 'Easy Payment',
    desc: 'Fund your wallet easily via bank transfer. Automated funding available 24/7.',
    icon: IconCreditCard,
    tone: 'green' as const,
  },
];

export function ServicesSection() {
  return (
    <section id="services" className="py-20">
      <div className="container-page">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle mx-auto">
            Everything You Need, One Platform
          </p>
          <p className="mt-2 text-sm text-brand-muted">
            From data and airtime to bills payment and education pins, ASDATALINK has got you covered with the best rates in Nigeria.
          </p>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service) => (
            <article
              key={service.title}
              className="group rounded-2xl border border-gray-100 bg-white p-6 shadow-soft transition-all hover:border-primary/40 hover:shadow-card"
            >
              <ServiceIconBox icon={service.icon} tone={service.tone} />
              <h3 className="text-lg font-bold text-brand-navy">{service.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-brand-muted">{service.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export function NetworksSection() {
  const networks = [
    { name: 'MTN', logo: '/assets/networks/mtn.png' },
    { name: 'Airtel', logo: '/assets/networks/airtel.png' },
    { name: 'Glo', logo: '/assets/networks/glo.png' },
    { name: '9mobile', logo: '/assets/networks/9mobile.png' },
  ];

  return (
    <section className="pb-20">
      <div className="container-page">
        <div className="rounded-3xl border border-gray-100 bg-brand-surface/60 px-6 py-12 sm:px-10">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-brand-navy sm:text-3xl">All Major Networks Supported</h2>
            <p className="mt-2 text-sm text-brand-muted">Buy data and airtime for any Nigerian network</p>
          </div>

          <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {networks.map((network) => (
              <div
                key={network.name}
                className="flex flex-col items-center justify-center rounded-2xl border border-gray-100 bg-white px-4 py-8 shadow-sm transition-all hover:border-primary/50 hover:shadow-md"
              >
                <img src={network.logo} alt={network.name} className="h-12 w-12 object-contain" />
                <span className="mt-3 text-sm font-semibold text-brand-navy">{network.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
